import React from 'react'
import CloudStorage from '../../../CloudStorage/CloudStorage'

const NotFound = ({ title }) => {
  return (
    <div className='text-center datanotfound col-md-12'>
      <img src={`${CloudStorage.cloudurl}/Assets/Images/common/datanotfound.png`} alt="" />
      {/* <h3>{title}</h3> */}
      <h3>No Task Available</h3>
      {/* <button className='browse-job buttons background-button mx-auto w-25'>Browse jobs</button> */}
    </div>
  )
}

export default NotFound
